import type { Command } from '../sim/commands';
import type { Simulation } from '../sim/sim';

/** The only mutation path from UI/input into the simulation. */
export class CommandBus {
  private readonly sim: Simulation;
  /** UI-side observer of player intent (the audio layer listens here — the
   * sim's events alone can't distinguish e.g. placement from demolition). */
  onDispatch: ((command: Command) => void) | null = null;

  constructor(sim: Simulation) {
    this.sim = sim;
  }

  dispatch(command: Command): void {
    this.onDispatch?.(command);
    this.sim.enqueue(command);
  }
}
